export default __webpack_public_path__ + "16b5e9f666b4cb094775044dc7f01a17.png";